export default __webpack_public_path__ + "static/wearable-header-444be49f4415324774b3a2405033f68e.jpg";